var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19.009,
    viewBox: "0 0 22 19.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_visibility_off_24px",
    d: "M12.005,7a5,5,0,0,1,5,5,4.855,4.855,0,0,1-.36,1.831l2.921,2.921A11.823,11.823,0,0,0,23,12,11.832,11.832,0,0,0,11.995,4.5a11.651,11.651,0,0,0-3.982.7l2.161,2.161A4.855,4.855,0,0,1,12.005,7ZM2,4.271,4.281,6.552l.46.46A11.809,11.809,0,0,0,1,12a11.827,11.827,0,0,0,15.387,6.663l.42.42,2.931,2.921,1.271-1.271L3.271,3ZM7.533,9.8l1.551,1.551A2.822,2.822,0,0,0,9,12a3,3,0,0,0,3,3,2.822,2.822,0,0,0,.65-.08l1.551,1.551A4.97,4.97,0,0,1,7.533,9.8Zm4.312-.78L15,12.174l.02-.16a3,3,0,0,0-3-3Z",
    transform: "translate(-1 -3)",
    fill: "#4a90f7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpHidden);
export default __webpack_public_path__ + "static/media/op-hidden.4a111cb3f161c617dd1a39ed056a1b9b.svg";
export { ForwardRef as ReactComponent };